<template>
    <div>
        <v-container class="app-breadcrumbs-container">
            <v-breadcrumbs class="app-breadcrumbs" :items="breadcrumbs">
                <v-icon slot="divider">chevron_right</v-icon>
                <template slot="item" slot-scope="props">
                    <router-link
                        :to="props.item.to"
                        :class="[
              props.item.disabled && 'v-breadcrumbs__item--disabled',
              'app-breadcrumbs__item'
            ]"
                    >
                        {{ props.item.text }}
                    </router-link>
                </template>
            </v-breadcrumbs>
        </v-container>
        <div class="main-title">
            <v-container fill-height>
                <v-layout align-center> {{ $t("account.title") }}</v-layout>
            </v-container>
        </div>
        <v-container>
            <v-layout :column="breakpoint.smAndDown">
                <v-flex
                    xs3
                    class="menu-wrapper"
                    :class="{ break: breakpoint.smAndDown }"
                >
                    <v-layout column class="menu-container">
                        <v-flex>
                            <router-link class="menu-item" :to="{ name: 'order/list' }">
                                {{ $t("account.order_list") }}
                            </router-link>
                        </v-flex>
                        <v-flex>
                            <router-link class="menu-item" :to="{ name: 'order/appointment' }">
                                {{ $t("account.appointment_order") }}
                            </router-link>
                        </v-flex>
                        <v-flex>
                            <router-link class="menu-item" :to="{ name: 'reset-password' }">
                                {{ $t("account.reset_password") }}
                            </router-link>
                        </v-flex>
                        <v-flex>
                            <router-link class="menu-item" :to="{ name: 'account/edit' }">
                                {{ $t("account.edit") }}
                            </router-link>
                        </v-flex>
                        <v-flex>
                            <router-link class="menu-item" :to="{ name: 'address' }">
                                {{ $t("account.address") }}
                            </router-link>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs9>
                    <v-layout column class="content">
                        <v-flex>
                            <div class="account-tip">
                                {{ $t("account.tip") }}
                            </div>
                        </v-flex>
                        <v-layout mb-3 wrap :column="breakpoint.smAndDown">
                            <v-flex xs6 class="account-title">
                                <span class="account-item">Email: </span>
                                <span>{{ userInfo.email }}</span>
                            </v-flex>
                            <v-flex xs6 class="account-title">
                                <span class="account-item">Name: </span>
                                <span>{{ userInfo.name }}</span>
                            </v-flex>
                            <v-flex xs6 class="account-title">
                                <span class="account-item">Phone: </span>
                                <span>{{ userInfo.phone || "null" }}</span>
                            </v-flex>
                        </v-layout>
                        <v-flex>
                            <button class="button shadow" @click="handleLogout">
                                {{ $t("account.btn") }}
                            </button>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("account.tip_title") }}</span>
                </v-card-title>
                <v-card-text>
                    <small>{{ $t("account.confrim_logout") }}</small>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="dialog = false">
                        {{ $t("account.cancel") }}
                    </v-btn>
                    <v-btn color="blue darken-1" flat @click="confrimLogout">
                        {{ $t("account.confrim") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";
import account from "@/api/account";

export default {
    data() {
        return {
            dialog: false
        };
    },
    computed: {
        ...mapState(["userInfo"]),
        breadcrumbs() {
            return [
                {
                    to: {name: "home"},
                    disabled: false,
                    text: this.$t("breadcrumbs.home")
                },
                {
                    to: {name: "account/info"},
                    disabled: false,
                    text: this.$t("breadcrumbs.account")
                }
            ];
        },
        breakpoint() {
            return this.$vuetify.breakpoint;
        }
    },
    created() {
        this.loadCustomer();
    },
    methods: {
        ...mapMutations(["setUserInfo", "logout"]),
        handleLogout() {
            this.dialog = true;
        },
        async loadCustomer() {
            try {
                const res = await account.loadCustomer();

                if (!res.data.isError) {
                    this.setUserInfo(res.data.data);
                }
            } catch (e) {
                console.error(e);
            }
        },
        confrimLogout() {
            this.dialog = false;
            this.logout();
            this.$router.push({name: "login"});
        }
    }
};
</script>

<style scoped lang="sass" src="./account.sass"></style>
